import { render } from "./CallWords.vue?vue&type=template&id=fa6c2724&ts=true"
import script from "./CallWords.vue?vue&type=script&lang=ts&setup=true"
export * from "./CallWords.vue?vue&type=script&lang=ts&setup=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/pages/call/components/CallWords.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "fa6c2724"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('fa6c2724', __exports__)) {
    api.reload('fa6c2724', __exports__)
  }
  
  module.hot.accept("./CallWords.vue?vue&type=template&id=fa6c2724&ts=true", () => {
    api.rerender('fa6c2724', render)
  })

}


export default __exports__